import { gql } from '@apollo/client';

import { interactiveLessonSectionOverviewFragment } from '../lesson-builder.graphql';
import { interactiveContentStyleBackgroundFragment } from '../styles/styles.graphql';
import { completionFragment } from 'approot/planner/manage/planner.graphql';

export const interactiveAssessmentFragment = gql`
  fragment AssessmentActivities on AssessmentActivities {
    id
    language
    date
    landscapeImage {
      key
      fileName
      original
      alt
      data {
        flip
      }
      responsive {
        width
        height
        urls {
          url
          quality
        }
      }
    }
    landscapeImageSourceUrl
    styles {
      fontSize
      ...InteractiveContentStyleBackground
    }
    assessment {
      authorId
      isAssigned
      assignedData {
        activitiesBookmarks {
          version
          sectionIds
        }
      }
      slug
      name
      years {
        name
      }
      unit {
        id
        name
      }
      subjects {
        id
        label
        colour
        name
      }
      landscapeImage {
        responsive {
          width
          height
          urls {
            url
            quality
          }
        }
      }
      completion {
        ...Completion
      }
    }
    sectionsOverview {
      ...InteractiveLessonSectionOverview
    }
    status
    version
    hasUnpublishedChanges
    isAutomarkable
    downloadUrl
    printPdfKey
    studentPrintables {
      downloadUrl
      previewUrl
    }
    assessmentName
    assetKeys {
      print {
        language
        key
        publicToken
      }
      studentPrintables {
        language
        key
        publicToken
      }
    }
    assetDownloadUrls {
      language
      url
    }
    availableTranslations
  }
  ${interactiveLessonSectionOverviewFragment}
  ${interactiveContentStyleBackgroundFragment}
  ${completionFragment}
`;

export const GET_DRAFT_ASSESSMENT_ACTIVITIES = gql`
  query GetDraftAssessmentActivities($input: GetAssessmentActivitiesInput!) {
    getDraftAssessmentActivities(input: $input) {
      id
      language
      date
      landscapeImage {
        key
        fileName
        original
        alt
        data {
          flip
        }
        responsive {
          width
          height
          urls {
            url
            quality
          }
        }
      }
      landscapeImageSourceUrl
      styles {
        fontSize
        ...InteractiveContentStyleBackground
      }
      assessment {
        authorId
        isAssigned
        assignedData {
          activitiesBookmarks {
            version
            sectionIds
          }
        }
        slug
        name
        years {
          name
        }
        unit {
          id
          name
        }
        subjects {
          id
          label
          colour
          name
        }
        landscapeImage {
          responsive {
            width
            height
            urls {
              url
              quality
            }
          }
        }
        completion {
          ...Completion
        }
      }
      sectionsOverview {
        ...InteractiveLessonSectionOverview
      }
      status
      hasUnpublishedChanges
      isAutomarkable
      downloadUrl
      printPdfKey
      studentPrintables {
        downloadUrl
        previewUrl
      }
      assessmentName
      assetKeys {
        print {
          language
          key
          publicToken
        }
        studentPrintables {
          language
          key
          publicToken
        }
      }
      assetDownloadUrls {
        language
        url
      }
      availableTranslations
    }
  }
  ${interactiveLessonSectionOverviewFragment}
  ${interactiveContentStyleBackgroundFragment}
  ${completionFragment}
`;

export const BUILD_DRAFT_ASSESSMENT_ACTIVITIES = gql`
  mutation BuildDraftAssessmentActivities(
    $input: BuildDraftAssessmentActivitiesInput!
  ) {
    buildDraftAssessmentActivities(input: $input) {
      ...AssessmentActivities
    }
  }
  ${interactiveAssessmentFragment}
`;
